"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Breadcrumb = function Breadcrumb(_ref) {
  var as = _ref.as,
      link = _ref.link,
      text = _ref.text,
      first = _ref.first,
      section = _ref.section;
  return _react["default"].createElement(_styled.BreadcrumbLink, {
    as: as,
    noUnderline: section === 'home',
    to: link
  }, first ? null : _react["default"].createElement(_styled.BreadcrumbIcon, null), _react["default"].createElement(_styled.BreadcrumbText, null, text));
};

var _default = Breadcrumb;
exports["default"] = _default;

//# sourceMappingURL=Breadcrumb.js.map